import styled, { css } from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #eee;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  h3 {
    margin: 0;
    color: #444;
    font-size: 16px;
    font-weight: 600;
  }

  small {
    display: block;
    margin-top: 4px;
    color: #777;
    font-size: 12px;
    line-height: 1.2;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f2f2f2;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;

  max-height: calc(90vh - 64px);
  overflow-y: auto;

  @media (max-width: 600px) {
    padding: 16px;
    max-height: calc(90vh - 56px);
  }
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #eee;
`;

export const UploadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  border: 1px solid #d6d9e2;
  background: #ffffff;
  color: #111827;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 700;
  cursor: pointer;

  transition: background 120ms ease, border-color 120ms ease, transform 120ms ease;

  &:hover {
    background: #f7f7fb;
    border-color: #cfd3de;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    transform: none;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const HelperText = styled.p`
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.3;
`;

export const EmptyState = styled.div`
  background: #ffffff;
  border: 1px dashed #d6d9e2;
  border-radius: 12px;
  padding: 16px;
  color: #6b7280;

  p {
    margin: 0;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 10px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Input = styled.input`
  height: 40px;
  border-radius: 10px;
  border: 1px solid #d6d9e2;
  padding: 0 10px;
  outline: none;
  color: #111827;

  &:focus {
    border-color: #bfc6d6;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  border: 1px solid #2563eb;
  background: #2563eb;
  color: #ffffff;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 800;
  cursor: pointer;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  border: 1px solid #d6d9e2;
  background: #ffffff;
  color: #111827;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 800;
  cursor: pointer;
`;

export const ErrorText = styled.div`
  margin-top: 8px;
  color: #b42318;
  font-size: 12px;
  font-weight: 700;
`;

export const SuccessText = styled.div`
  margin-top: 8px;
  color: #1b7a3a;
  font-size: 12px;
  font-weight: 700;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 12px;
    color: #374151;
    font-weight: 800;
    letter-spacing: 0.2px;
  }
`;

export const FilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FileItem = styled.div`
  background: #f9f9f9;
  padding: 12px 16px;
  border-radius: 6px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    color: #333;
    word-break: break-word;
  }

  span {
    font-size: 12px;
    color: #888;
    word-break: break-word;
  }
`;

export const FileActions = styled.div`
  display: flex;
  gap: 16px;

  svg {
    cursor: pointer;
    color: #6ea5ff;
  }

  svg:last-child {
    color: #e74c3c;
  }

  @media (max-width: 600px) {
    width: 100%;
    justify-content: flex-end;
  }
`;

export const PreviewContainer = styled.div`
  margin-top: 24px;
  border-top: 1px solid #eee;
  padding-top: 16px;

  iframe {
    width: 100%;
    height: 500px;
    border: none;
    border-radius: 6px;
  }

  img {
    max-width: 100%;
    max-height: 500px;
    display: block;
    margin: 0 auto;
    border-radius: 6px;
  }

  @media (max-width: 600px) {
    iframe {
      height: 360px;
    }

    img {
      max-height: 360px;
    }
  }
`;

export const InfoCard = styled.div`
  color: #374151;

  label {
    display: block;
    font-size: 12px;
    font-weight: 800;
    margin-bottom: 6px;
    color: #374151;
  }

  .items {
    font-size: 12px;
    color: #6b7280;
    line-height: 1.35;
  }
`;

export const FilesSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CenterLoading = styled.div`
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InitialLoadingWrap = styled.div`
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
